
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/9f17768f-557a-422c-acf8-71d99eebfaaf.png" 
              alt="LBA Construct Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm">
              Uw betrouwbare partner in dakwerken & renovatie.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Diensten</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#diensten" className="hover:text-white transition-colors cursor-pointer">Dakwerken</a></li>
              <li><a href="#diensten" className="hover:text-white transition-colors cursor-pointer">Zolder Isolatie</a></li>
              <li><a href="#diensten" className="hover:text-white transition-colors cursor-pointer">Gyproc & Bezetting</a></li>
              <li><a href="#diensten" className="hover:text-white transition-colors cursor-pointer">Loodgieterij</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Snelle Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#waarom-lba" className="hover:text-white transition-colors cursor-pointer">Over Ons</a></li>
              <li><a href="#realisaties" className="hover:text-white transition-colors cursor-pointer">Realisaties</a></li>
              <li><a href="#contact-form" className="hover:text-white transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>2170 Merksem</li>
              <li><a href="tel:+32483599049" className="hover:text-white transition-colors cursor-pointer">+32 483 599 049</a></li>
              <li><a href="mailto:info@lbaconstruct.be" className="hover:text-white transition-colors cursor-pointer">info@lbaconstruct.be</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © 2025 LBA Construct. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>
  );
}
